/*

Google Map

*/

import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import SbEditable from "storyblok-react";

const googleMapStyles = require("./GoogleMapStyles.json");

const containerStyle = {
  width: "95%",
  height: "545px",
};

const center = {
  lat: 51.49908409381832,
  lng: -0.09834911755625396,
};

const position = {
  lat: 51.49908409381832,
  lng: -0.09834911755625396,
};

const GoogleMaps = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="my-16 md:my-32 lg:my-40 mx-auto flex item-center justify-center">
        <LoadScript googleMapsApiKey="AIzaSyCojalgf3Ff7vrjGMxjan_o-aNe5vhWeMA">
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
            options={{ styles: googleMapStyles }}
          >
            {
              /* Child components, such as markers, info windows, etc. */

              <Marker
                position={position}
                icon={{
                  url: "https://a.storyblok.com/f/322427/52178c6470/map-marker.svg",
                }}
              />
            }

            <></>
          </GoogleMap>
        </LoadScript>
      </div>
    </SbEditable>
  );
};

export default GoogleMaps;
